/*
* 点位信息组件
* zxw
* 创建时间：2025-05-21
*/

import { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    Modal,
    Button,
    Image,
    ConfigProvider,
    message,
} from 'antd';
import {
    locale,
    Html2pdf,
    UjoinParams,
    AddRequestHeaders,
    defaultImage,
    AliyunOSSclient,
} from '../../incs/FunHelper.js';

import XZTLOGO from '../../images/logo-head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

/***
 * 打印点位信息
*/
const PLInfo = (props) => {
    const [open, setOpen] = useState(props.isModalOpen);
    const [ulid, setUlid] = useState('');
    const [fileILIPList, setFileILIPList] = useState([]);
    const [fileCELIPList, setFileCELIPList] = useState([]);

    const cancel = () => {
        setOpen(false);
        setUlid('');
        setFileILIPList([]);
        setFileCELIPList([]);
    }
    const printer = () => {
        var printContents = document.getElementById('printer-print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    }
    const download = () => {
        Html2pdf('printer-print-info-id', props.record.number, '', fileILIPList.length > 0 || fileCELIPList.length > 0 ? true : false);
    }

    useEffect(() => {
        setOpen(props.isModalOpen);
    }, [props]);

    // 修改初始化图片
    useEffect(() => {
        /**
         * 获取图片对象
         * @param {*} path 
         * @param {*} tag 
         */
        const getImageObj = (path, tag) => {
            let params = { 'acl': 'GetObject' }
            $.ajax({
                url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        const token = data.dat;
                        try {
                            let arr = path.split('/');
                            //  去掉路径‘/’
                            let result = AliyunOSSclient(token).signatureUrl(path, {
                                expires: 3600,
                                response: {
                                    'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                                }
                            });
                            tag === "ILIP" ? setFileILIPList(prevItems => {
                                let newItems = [...prevItems]; // 创建数组的副本
                                newItems[0] = {
                                    ...newItems[0],
                                    percent: 100,
                                    url: result,
                                    preview: result,
                                    status: 'done',
                                    path: path,
                                    name: arr[arr.length - 1],
                                }; // 更新对象
                                return newItems; // 返回新的数组
                            }) : setFileCELIPList(prevItems => {
                                let newItems = [...prevItems]; // 创建数组的副本
                                newItems[0] = {
                                    ...newItems[0],
                                    percent: 100,
                                    url: result,
                                    preview: result,
                                    status: 'done',
                                    path: path,
                                    name: arr[arr.length - 1],
                                }; // 更新对象
                                return newItems; // 返回新的数组
                            });
                        } catch (e) {
                            // console.log(e);
                        }
                    } else {
                        message.error(data.msg, CNF.messageDuration);
                    }
                }
            });
        }
        setUlid(props.record.key);
        if (props.record) {
            if (props.record.installation_location_image_path && (fileILIPList.length < 1 || props.record.key !== ulid)) {
                getImageObj(props.record.installation_location_image_path, 'ILIP');
            }
            if (props.record.connect_electricity_location_image_path && (fileCELIPList.length < 1 || props.record.key !== ulid)) {
                getImageObj(props.record.connect_electricity_location_image_path, 'CELIP');
            }
        }
    }, [props.record, ulid, fileILIPList, fileCELIPList]);

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            <Modal
                style={{ top: 0 }}
                closable={false}
                maskClosable={true}
                open={open}
                keyboard={true}
                width={820}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='submit' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} style={{ marginRight: '24px' }}>下载</Button>,
                ]}
            >
                <div id='printer-print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height={'45px'} alt={CNF.companyShortName} /></Col>
                            <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt={CNF.companyShortName} /></Col>
                        </Row>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th style={{ padding: '5px 10px' }} colSpan='24' ><h2>点位信息采集表</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td colSpan='24' style={{ width: 720 }}><strong>1.基本信息</strong></td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>点位编号</td><td colSpan='8' style={{ width: 240 }}>{props.record.number}</td>
                                    <td colSpan='4' style={{ width: 120 }}>点位名称</td><td colSpan='8' style={{ width: 240 }}>{props.record.name}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>所属辖区</td><td colSpan='8' style={{ width: 240 }}>{props.record.police_station}</td>
                                    <td colSpan='4' style={{ width: 120 }}>点位详细地址</td><td colSpan='8' style={{ width: 240 }}>{props.record.address}</td>
                                </tr>
                                <tr><td colSpan='24' style={{ width: 720 }}><strong>2.设备配置</strong></td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>一杆几机</td><td colSpan='8' style={{ width: 240 }}>{props.record.rod_device_count}个</td>
                                    <td colSpan='4' style={{ width: 120 }}>机型选择</td><td colSpan='8' style={{ width: 240 }}>
                                        {
                                            props.record.high_ball > 0 ? '球机' + props.record.high_ball + '个；' : ''
                                        }
                                        {
                                            props.record.double_cabins > 0 ? '双舱' + props.record.double_cabins + '个；' : ''
                                        }
                                        {
                                            props.record.double_pinyin > 0 ? '双拼' + props.record.double_pinyin + '个；' : ''
                                        }
                                        {
                                            props.record.old_equipment > 0 ? '利旧' + props.record.old_equipment + '个；' : ''
                                        }
                                        {
                                            props.record.vehicle_checkpoint > 0 ? '大卡' + props.record.vehicle_checkpoint + '个；' : ''
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>抱杆箱</td><td colSpan='8' style={{ width: 240 }}>{
                                        props.record.intelligent_box > 0 ? props.record.intelligent_box + '个' : '-'
                                    }</td>
                                    <td colSpan='4' style={{ width: 120 }}>安装方式</td><td colSpan='8' style={{ width: 240 }}>{props.record.installation_method}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>杆型</td><td colSpan='8' style={{ width: 240 }}>{props.record.rod_type ? props.record.rod_type : '-'}</td>
                                    <td colSpan='4' style={{ width: 120 }}>建议高度</td><td colSpan='8' style={{ width: 240 }}>{
                                        props.record.installation_height ? props.record.installation_height : '-'
                                    }</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>杆高</td><td colSpan='8' style={{ width: 240 }}>{
                                        props.record.rod_height > 0 ? props.record.rod_height + 'm' : '-'
                                    }</td>
                                    <td colSpan='4' style={{ width: 120 }}>臂长</td><td colSpan='8' style={{ width: 240 }}>{
                                        props.record.arm_length ? props.record.arm_length : '-'
                                    }</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>臂朝向</td><td colSpan='8' style={{ width: 240 }}>{props.record.arm_orientation}</td>
                                    <td colSpan='4' style={{ width: 120 }}>防控区域</td><td colSpan='8' style={{ width: 240 }}>{props.record.control_area}</td>
                                </tr>
                                <tr><td colSpan='24' style={{ width: 720 }}><strong>3.施工信息</strong></td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>接电方式</td><td colSpan='8' style={{ width: 240 }}>{props.record.connect_electricity_method}</td>
                                    <td colSpan='4' style={{ width: 120 }}>路面开挖长度</td><td colSpan='8' style={{ width: 240 }}>
                                        {
                                            props.record.dirt_road > 0 ? '泥土路面' + props.record.dirt_road + 'm；' : ''
                                        }
                                        {
                                            props.record.cement_road > 0 ? '水泥路面' + props.record.cement_road + 'm；' : ''
                                        }
                                        {
                                            props.record.asphalt_road > 0 ? '沥青路面' + props.record.asphalt_road + 'm；' : ''
                                        }
                                        {
                                            props.record.sidewalk > 0 ? '人行道' + props.record.sidewalk + 'm；' : ''
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>电源长度</td><td colSpan='8' style={{ width: 240 }}>{props.record.power_supply_length}m</td>
                                    <td colSpan='4' style={{ width: 120 }}>接电位置</td><td colSpan='8' style={{ width: 240 }}>{props.record.connect_electricity_location}</td>
                                </tr>
                                <tr><td colSpan='24' style={{ width: 720 }}><strong>4.地里与时间信息</strong></td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>采集日期</td><td colSpan='8' style={{ width: 240 }}>{props.record.collection_date}</td>
                                    <td colSpan='4' style={{ width: 120 }}>经纬度</td><td colSpan='8' style={{ width: 240 }}>{props.record.longitude_latitude}</td>
                                </tr>
                                <tr><td colSpan='24' style={{ width: 720 }}><strong>5.图片信息</strong></td></tr>
                                <tr>
                                    <td colSpan='12' style={{ width: 360 }}>安装位置</td>
                                    <td colSpan='12' style={{ width: 360 }}>接电位置</td>
                                </tr>
                                <tr>
                                    <td colSpan='12' style={{ width: 360 }}>
                                        {
                                            props.record.installation_location_image_path && fileILIPList.length > 0 ? (
                                                <ConfigProvider locale={locale}>
                                                    {
                                                        fileILIPList.map((item, index) => {
                                                            return <Image
                                                                className='whole-node'
                                                                key={index}
                                                                alt={item.name}
                                                                width='100%'
                                                                src={item.url}
                                                                style={{ verticalAlign: 'top', maxWidth: '100%', height: 'auto', aspectRatio: 5 / 3 }}
                                                                fallback={defaultImage}
                                                            />
                                                        })
                                                    }
                                                </ConfigProvider>
                                            ) : '-'
                                        }
                                    </td>
                                    <td colSpan='12' style={{ width: 360 }}>
                                        {
                                            props.record.connect_electricity_location_image_path && fileCELIPList.length > 0 ? (
                                                <ConfigProvider locale={locale}>
                                                    {
                                                        fileCELIPList.map((item, index) => {
                                                            return <Image
                                                                className='whole-node'
                                                                key={index}
                                                                alt={item.name}
                                                                width='100%'
                                                                src={item.url}
                                                                style={{ verticalAlign: 'top', maxWidth: '100%', height: 'auto', aspectRatio: 5 / 3 }}
                                                                fallback={defaultImage}
                                                            />
                                                        })
                                                    }
                                                </ConfigProvider>
                                            ) : '-'
                                        }
                                    </td>
                                </tr>
                                <tr><td colSpan='24' style={{ width: 720 }}><strong>6.备注</strong></td></tr>
                                {
                                    props.record.description ? <tr><td colSpan='24' style={{ width: 720 }}>
                                        {props.record.description && props.record.description.split('\n').map((item, index) => {
                                            return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr> : ''
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal >
        </ConfigProvider>
    );
}

export default PLInfo;